import { EvieOrb } from './EvieOrb';
import { useEvieStore } from '@/store/evie';
import styles from './EvieLauncherButton.module.css';

/**
 * Header launcher for the admin EVII chat — lives next to the theme picker.
 * Tapping it toggles the chat (open the popup, or close from any open state).
 *
 * The icon glows while voice mode is live: it reads `voiceActive` from the evie
 * store (which the chat's voice loop sets) and lights the `.glow` class. The
 * `glow` prop stays as an optional manual override (default false) so a caller
 * can force the glow without the store, but voice-active is the real driver.
 */
export function EvieLauncherButton({ glow = false }: { glow?: boolean }) {
  const view = useEvieStore((s) => s.view);
  const toggle = useEvieStore((s) => s.toggle);
  const voiceActive = useEvieStore((s) => s.voiceActive);
  const active = view !== 'closed';
  // Glow while voice mode is live (store flag), or if a caller forces it.
  const glowing = glow || voiceActive;

  return (
    <button
      type="button"
      className={`${styles.launcher} ${active ? styles.active : ''} ${glowing ? styles.glow : ''}`}
      onClick={toggle}
      aria-label="EVII™ assistant"
      aria-pressed={active}
      title="EVII™ assistant"
    >
      <EvieOrb size={18} />
    </button>
  );
}
